import { useEffect, useState } from 'react';
import axios from '@helpers/axios';
import { strogging } from '@shd/jslib/infra';
import { useHistory } from 'react-router-dom';
import { PageType } from './handle.d';

const useHandle = (handle: string | null, queryParams: string | null) => {
  const [activeId, setActiveId] = useState<string>('');
  const [pageType, setPageType] = useState<PageType | null>(null);
  const history = useHistory();
  useEffect(() => {
    const fetchHandle = () => {
      axios
        .get(`/v2/utils/lookup/${handle}`)
        .then((res) => {
          const { nameHandleLower, id, type } = res.data;
          setActiveId(id);
          setPageType(type);
          const nameHandle = nameHandleLower ? nameHandleLower : handle;
          if (queryParams) {
            history.push(`/${nameHandle}${queryParams}`, { shallow: true });
          } else {
            history.push(`/${nameHandle}`, { shallow: true });
          }
        })
        .catch((err) => {
          const status = err.response?.status;
          history.push(`${status}/you-struckout?handle=${handle}`);
          strogging.error(err);
        });
    };

    fetchHandle();
  }, [handle, history, queryParams]);

  return { activeId, pageType };
};

export default useHandle;
